import { defineStore } from 'pinia'

import { TYPING_TIMEOUT } from '@shared/utils/constants/time'

interface TypingIndicatorState {
  conversationMap: Record<number, boolean>
  typingTimers: Record<number, NodeJS.Timeout | undefined>
}

export const useTypingIndicatorsStore = defineStore({
  id: 'typing-indicator',
  state: (): TypingIndicatorState => ({
    conversationMap: {},
    typingTimers: {},
  }),
  actions: {
    setTypingStatus(
      conversationId: number,
      isTyping: boolean,
      timeout = TYPING_TIMEOUT
    ) {
      if (this.typingTimers[conversationId]) {
        clearTimeout(this.typingTimers[conversationId])
      }

      this.conversationMap[conversationId] = isTyping

      // Set a new timer to reset typing status if 'isTyping' is not true within 1 second
      if (isTyping) {
        this.typingTimers[conversationId] = setTimeout(() => {
          this.resetTypingStatus(conversationId)
          delete this.typingTimers[conversationId] // Remove the timer reference
        }, timeout)
      }
    },

    resetTypingStatus(conversationId: number) {
      this.conversationMap[conversationId] = false
    },
  },
  getters: {
    getTypingStatus: (state) => (conversationId: number) => {
      return state.conversationMap[conversationId] || false
    },
  },
})
